import { render, staticRenderFns } from "./TrialLabsRadarChart.vue?vue&type=template&id=415a2899&scoped=true"
import script from "./TrialLabsRadarChart.vue?vue&type=script&lang=js"
export * from "./TrialLabsRadarChart.vue?vue&type=script&lang=js"
import style0 from "./TrialLabsRadarChart.vue?vue&type=style&index=0&id=415a2899&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "415a2899",
  null
  
)

export default component.exports